export enum FormName {
  NEWSLETTER_SIGNUP = 'newsletter-signup',
}
